import { encrypt, decrypt } from './crypto'

const userStorage = '__r9a0'
const tokenStorage = '__iix2'

export const setUserData = (user) => {
  const cipherText = encrypt(JSON.stringify(user))
  localStorage.setItem(userStorage, cipherText)
}

/**
  * Set authenticated user token
  * @param {String} token User token from api
  */
export const setUserToken = (token) => { 
  const cipherText = encrypt(JSON.stringify({ token }))
  localStorage.setItem(tokenStorage, cipherText)
}

export const getUserData = () => {
  let user = localStorage.getItem(userStorage)
  let data = localStorage.getItem(tokenStorage)
  if (!user || !data) {
    return unsetUser()
  }
  return JSON.parse(decrypt(user))
}

export const getUserToken = () => {
  try {
    let user = localStorage.getItem(userStorage)
    let data = localStorage.getItem(tokenStorage)
    if (!data || !user) {
      return unsetUser()
    }
    data = JSON.parse(decrypt(data))
    return data.token
  }
  catch (error) {
    return unsetUser()
  }
}

export const unsetUser = () => {
  localStorage.removeItem(userStorage)
  localStorage.removeItem(tokenStorage)
  // localStorage.clear()
}
